// System
import { Stack } from '@mui/system';

// Features
import { TestsForm } from '@Features/tests/TestsForm';

export const TestsPage = () => {
  return (
    <Stack direction="column" spacing={2}>
      <TestsForm />
    </Stack>
  );
};
